import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Composant de route protégée pour l'administration
 * Redirige vers la page d'accueil si l'utilisateur n'est pas connecté ou n'est pas administrateur
 */
const AdminRoute = () => {
  const { currentUser, loading } = useAuth();
  
  // Si le chargement est en cours, afficher un indicateur de chargement
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Chargement...</p>
      </div>
    );
  }
  
  // Vérifier si l'utilisateur est connecté et est administrateur
  if (!currentUser || !currentUser.isAdmin) {
    return <Navigate to="/" replace />;
  }
  
  // Si l'utilisateur est connecté et est administrateur, afficher le contenu de la route
  return <Outlet />;
};

export default AdminRoute;
